// Application
import ExclamationMark from 'assets/exclamation-mark.svg'
import { Analytics } from 'constants/index'

export enum AccountExistsModalInstances {
    accountCipOrphanAccountExists = 'accountCipOrphanAccountExists',
}

export interface TrackEventProps {
    event: string
    steps: string
    path?: string
}

export interface AccountExistsModalProps {
    showModal: boolean
    image: string
    title: string
    subtitle: string
    link: {
        to: string
        text: string
    }
    trackEvent?: {
        event: string
        steps: string
        path?: string
    }
}

export const AccountExistsModalData: Record<AccountExistsModalInstances, AccountExistsModalProps> = {
    [AccountExistsModalInstances.accountCipOrphanAccountExists]: {
        image: ExclamationMark,
        subtitle: 'Encontrei uma conta cadastrada com seus dados. É só realizar o login para acessar os serviços.',
        title: 'Você já possui uma conta Nav Dasa',
        showModal: false,
        trackEvent: Analytics.ActivateAccountCipOrphan.ModalAccountNav,
        link: {
            to: '/login?origem=ativacao-cip',
            text: 'Fazer login',
        },
    },
}
